import { Analytics } from '@payu/paymentsos-types'

import apiConfig from '../../../../api/AnalyticsApiHelpers/apiConfig'
import { PaymentStageNamesTypes } from '../../components/paymentStagesConfig'

export default function convertRawDataToPaymentStagesData (
  data: Analytics.AnalyticsResponse
): null | MappedDataByPaymentStage {
  return dataIsEmpty(data) ? null : mapDataToPaymentStagesData(data)
}

function dataIsEmpty (data: Analytics.AnalyticsResponse): boolean {
  return !(data?.buckets?.length > 0)
}

export type MappedDataByPaymentStage = {
  [key in PaymentStageNamesTypes]?: Analytics.MetricsResponse
}

function mapDataToPaymentStagesData (data: Analytics.AnalyticsResponse): MappedDataByPaymentStage {
  const actualData = data.buckets[0].data
  return actualData.reduce((obj, curItem) => {
    obj[curItem.dimensions[apiConfig.dimensions.paymentStage] as PaymentStageNamesTypes] = curItem.metrics
    return obj
  }, {})
}
